<ng-container *ngIf="this.pagefound">
    <app-header></app-header>
</ng-container>

<ng-template #components></ng-template>
<ng-container *ngIf="this.pagefound">    
    <app-mobil-modal></app-mobil-modal>
    <app-passolig-mobil-modal></app-passolig-mobil-modal>
    <app-footer></app-footer>
</ng-container>